/* BETA_LOCKDOWN — tenant slug used to gate write operations in production */
export const PROD_TENANT_SLUG = "prod" as const;
